// Auto-generated by scripts/gen-manifest.js. Do not edit by hand —
// re-run `npm run gen-manifest` after adding/removing references.
export const AVAILABLE_MARC_IDS = [
  "001",
  "002",
  "003",
  "004",
  "006",
  "007",
  "008",
  "009",
  "010",
  "011",
  "012",
  "013",
  "014",
  "015",
  "016",
  "017",
  "018",
  "019",
  "020"
];
